"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Grid.default;
  }
});
var _Grid = _interopRequireDefault(require("./Grid.js"));
module.exports = exports.default;
module.exports.default = exports.default;